export default "__VITE_ASSET__B6_FgHjS__"